import React from "react";

import DuplicateDestinationForm from "v2/components/responsive/DuplicateDestinationForm";

const MoveDestinationForm = (props) => {
  return (
    <DuplicateDestinationForm
      action="move"
      btnSubmitLabel="Move"
      ignoreRouteId
      modalTitle="Move Destination"
      pageTitle="Move Destination"
      {...props} />
  );
};

export default MoveDestinationForm;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/MoveDestinationForm.js
 **/